<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  
}
</script>

<style scoped>
@font-face {
  font-family: "PassionOne";
  src: local("PassionOne"), url(./fonts/PassionOne.ttf) format("truetype");

  font-family: "GillSans";
  src: local("PassionOne"), url(./fonts/GillSans.otf) format("truetype");

  font-family: "GTAmerica";
  src: local("GTAmerica"), url(./fonts/GTAmerica.ttf) format("truetype");

  font-family: "WorkSans";
  src: local("WorkSans"), url(./fonts/WorkSans.ttf) format("truetype");
}
</style>